import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig, {CONFIG_PARAMS} from "./SystemConfig";
import Connect from "../connect/Connect";
import IEventObserver from "../events/IEventObserver";
import {EVENTS} from "../events/baseEvents";
import {ERROR_EVENTS} from "../connect/controllers/ConnectControl";
import {closeWindow} from "./closeWindow";
import InitWallet from "../wallet/InitWallet";
import events from "../events/EventsObservable";
import IErrorHandler from "../error/IErrorHandler";
import Wallet from "../wallet/Wallet";
import IStatesManager from "../states/IStatesManager";

@injectable()
export default class System implements IEventObserver {

    public readonly config: SystemConfig;
    public readonly initWallet: InitWallet;
    public readonly wallet: Wallet;
    public readonly errorHandler: IErrorHandler;
    public readonly states: IStatesManager;

    private connect: Connect;
    private unloading: boolean;

    // private socketType: string;
    // private initResult: InitResult;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.ErrorHandler) errorHandler: IErrorHandler,
        @inject(SERVICE_IDENTIFIER.InitWallet) initWallet: InitWallet,
        @inject(SERVICE_IDENTIFIER.Connect) connect: Connect,
        @inject(SERVICE_IDENTIFIER.StatesManager) statesManager: IStatesManager
    ) {

        this.config = config;
        this.errorHandler = errorHandler;
        this.states = statesManager;
        this.connect = connect;
        this.initWallet = initWallet;
        this.wallet = initWallet.getWallet();
        this.unloading = false;

        events.subscribe(EVENTS.CLOSE_GAME, this);
        events.subscribe(ERROR_EVENTS.ERROR_LOGOUT, this);
        // events.subscribe(EVENTS.WINDOW_UNLOAD, this);
    }

    notify(eventName, data) {

        switch (eventName) {
            case EVENTS.CLOSE_GAME:
                this.closeGame();
                break;
            case ERROR_EVENTS.ERROR_LOGOUT:
                this._logout();
                break;
            // case EVENTS.WINDOW_UNLOAD:
            //     this._unload();
            //     break;
        }
    }



    // /**
    //  * @param {InitResult} initResult
    //  * @private
    //  */
    // _onInitSuccess(initResult) {
    //
    //     this.config.initResult(initResult);
    //
    //     this.initWallet.init(initResult);
    //
    //     events.dispatch(EVENTS.INIT_SUCCESS, initResult);
    // }

    // async _initWebSocket(initResult, socketType: string) {
    //
    //     if(!initResult.getWebSocket() || !socketType) {
    //         return Promise.resolve();
    //     }
    //
    //     this.config.set(CONFIG_PARAMS.WEB_SOCKET, initResult.getWebSocket());
    //
    //     let params = {
    //         sessionId: this.config.get(CONFIG_PARAMS.SESSION_ID),
    //         sessionKey: this.config.get(CONFIG_PARAMS.SESSION_KEY),
    //         casinoId: this.config.get(CONFIG_PARAMS.CASINO_ID)
    //     };
    //
    //     return this.connect.socket(params, socketType);
    // }

    async closeGame() {

        try {
            await this._connectionClose();
        } catch(e) {
            console.log(e);
        } finally {
            closeWindow(this.config);
        }
    }

    async _logout() {

        console.log("logging out");

        try {
            this._connectionClose();
        } catch(e) {
            console.log(e);
        }
    }

    async _connectionClose() {
        //websocket close
        await this._closeFetch();
    }

    /**
     * @param {Connect} connect
     * @return {Promise<*>}
     * @private
     */
    async _closeFetch() {

        if(!this.config.get(CONFIG_PARAMS.SESSION_ID)) {
            console.log("Error closeFetch: Session ID not found");
            return;
        }

        let params = {
            serverApi: this.config.get(CONFIG_PARAMS.SERVER_API),
            sessionId: this.config.get(CONFIG_PARAMS.SESSION_ID),
            casinoId: this.config.get(CONFIG_PARAMS.CASINO_ID),
        };

        console.log("fetch close");

        return await this.connect.close(params);
    }

    async unload() {

        if(this.config.get(CONFIG_PARAMS.WEB_SOCKET) || this.config.get(CONFIG_PARAMS.PLAYTECH_CLIENT_PLATFORM)) {

            if(this.unloading) {
                console.warn("unloaded");
                return;
            }

            this.unloading = true;

            console.warn("start unloading");

            let params = {
                serverApi: this.config.get(CONFIG_PARAMS.SERVER_API),
                sessionId: this.config.get(CONFIG_PARAMS.SESSION_ID),
                casinoId: this.config.get(CONFIG_PARAMS.CASINO_ID),
            };

            if(!navigator.sendBeacon) {
                await this.connect.close(params);
                return;
            }

            return this.connect.beacon(params);
        }
    }
}